import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface ReportFilter {
  code_start?: string;
  code_end?: string;
}

export interface CurrencyItem {
  code: string;    // f108_01
  name_zh: string; // f108_11
  name_en: string; // f108_12
}

export interface ReportData {
  items: CurrencyItem[];
  total: number;
}

export interface ReportResponse {
  data?: ReportData;
  message?: string;
}

// ============================================================
// API Client
// ============================================================

export const p1308Api = {
  async query(filter: ReportFilter): Promise<ReportResponse> {
    const params: Record<string, string> = {};
    for (const [k, v] of Object.entries(filter)) {
      if (v && v.trim() !== '') {
        params[k] = v.trim();
      }
    }
    const res = await apiClient.get('/api/p1308/report', { params });
    return res.data;
  },
};
